import { get, post } from './utils';

export const getMarketingInfo = () => get('/marketing-info');
export const saveMarketingInfo = async params => post('/marketing-info', params);

export const marketingInformation = {
  getMarketingInfo,
  saveMarketingInfo
};
